// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"lka-z","beautyGrouping":"mka-z","beautySwatches":"nka-z","swatches":"oka-z"};